<template>
  <v-card-text ref='container' class='px-sm-12 flex-grow-1 pb-0 container'>
    <div ref='innerContainer' class='inner-container justify-center d-flex flex-column'>
      <div class='pb-2 text-center input-subtitle-text'>
        <slot name='subtext'>
          <ipa-text :text="mainText" :ipaText="subText" :wordMode="wordMode"/>
        </slot>
      </div>
      <div class='text-h3 text-center ipa-subtitle-text'>
        <slot name='maintext'>
          <ipa-text :text="mainText" :wordMode="wordMode"/>
        </slot>
      </div>
      <span v-show='isEmpty' class='text-h3 text-center ipa-subtitle-text'>{{ $i18n.t('empty_subtitles') }}</span>
    </div>
  </v-card-text>
</template>

<script>
import { defineComponent, computed, toRefs } from 'vue'
import IpaText from './IpaText';

export default defineComponent({
  components: {
    IpaText
  },
  props: {
    text: {
      type: String,
    },
    ipaText: {
      type: String
    },
    wordMode: {
      type: Boolean
    }
  },
  setup(props){
    const {
      text,
      ipaText
    } = toRefs(props);

    const subText = computed(()=>{
      return (text.value || ''); 
    })

    const mainText = computed(()=>{
      return (ipaText.value || '');
    })

    const isEmpty = computed(()=>{
      return !text.value && !ipaText.value;
    })

    return {
      subText,
      mainText,
      isEmpty
    }
  }
})
</script>

<style scoped lang="scss">
  .container{
    overflow: auto;
  }

  .inner-container{
    min-height: 100%;
  }

  .input-subtitle-text, .ipa-subtitle-text {
    word-break: keep-all;
  }

  .ipa-subtitle-text {
    // padding-bottom: 1em;
    word-spacing: 0.2em;
  }
</style>
